import React from 'react';

export default function DividerConfig({ data, onChange }) {
  return (
    <>
      <div className="adminblog-field">
        <label>Style</label>
        <div className="adminblog-status-toggle">
          {['line', 'dots', 'symbol', 'space'].map(style => (
            <button
              key={style}
              className={`adminblog-status-option ${data.style === style ? 'active' : ''}`}
              onClick={() => onChange({ ...data, style })}
            >
              {style.charAt(0).toUpperCase() + style.slice(1)}
            </button>
          ))}
        </div>
      </div>
      {data.style === 'symbol' && (
        <div className="adminblog-field">
          <label>Symbol</label>
          <input
            type="text"
            value={data.symbol || ''}
            onChange={(e) => onChange({ ...data, symbol: e.target.value })}
            placeholder="◇ or —"
            style={{ maxWidth: 120 }}
          />
        </div>
      )}
    </>
  );
}
